import React from "react";

interface GameControlsProps {
  moveCount: number;
  maxMoves: number;
  optimalMoves: number;
  canUndo: boolean;
  onUndo: () => void;
  onReset: () => void;
}

export function GameControls({
  moveCount,
  maxMoves,
  optimalMoves,
  canUndo,
  onUndo,
  onReset,
}: GameControlsProps) {
  return (
    <div className="flex items-center gap-4">
      <button
        onClick={onUndo}
        disabled={!canUndo}
        className="px-4 py-2 bg-slate-800 hover:bg-slate-700 disabled:opacity-40 disabled:cursor-not-allowed rounded-lg text-sm font-medium transition-colors border border-slate-600"
      >
        Undo
      </button>
      <button
        onClick={onReset}
        className="px-4 py-2 bg-slate-800 hover:bg-slate-700 rounded-lg text-sm font-medium transition-colors border border-slate-600"
      >
        Reset
      </button>
      <div className="text-sm text-slate-400">
        <span className="text-white font-mono">{moveCount}</span>
        {" / "}
        <span className="font-mono">{maxMoves}</span>
        {" drops"}
        <span className="ml-2 text-slate-600">(par: {optimalMoves})</span>
      </div>
    </div>
  );
}
